/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GetSavedAnnotationAdditionalContentResponse model module.
 * @module model/GetSavedAnnotationAdditionalContentResponse
 * @version 2.8.0
 */
class GetSavedAnnotationAdditionalContentResponse {
    /**
     * Constructs a new <code>GetSavedAnnotationAdditionalContentResponse</code>.
     * @alias module:model/GetSavedAnnotationAdditionalContentResponse
     */
    constructor() { 
        
        GetSavedAnnotationAdditionalContentResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GetSavedAnnotationAdditionalContentResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetSavedAnnotationAdditionalContentResponse} obj Optional instance to populate.
     * @return {module:model/GetSavedAnnotationAdditionalContentResponse} The populated <code>GetSavedAnnotationAdditionalContentResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetSavedAnnotationAdditionalContentResponse();

            if (data.hasOwnProperty('addedColumns')) {
                obj['addedColumns'] = ApiClient.convertToType(data['addedColumns'], [['String']]);
            }
            if (data.hasOwnProperty('addedColumnsProperties')) {
                obj['addedColumnsProperties'] = ApiClient.convertToType(data['addedColumnsProperties'], [Object]);
            }
            if (data.hasOwnProperty('knowledgeGraphResults')) {
                obj['knowledgeGraphResults'] = ApiClient.convertToType(data['knowledgeGraphResults'], [Object]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<Array.<String>>} addedColumns
 */
GetSavedAnnotationAdditionalContentResponse.prototype['addedColumns'] = undefined;

/**
 * @member {Array.<Object>} addedColumnsProperties
 */
GetSavedAnnotationAdditionalContentResponse.prototype['addedColumnsProperties'] = undefined;

/**
 * @member {Array.<Object>} knowledgeGraphResults
 */
GetSavedAnnotationAdditionalContentResponse.prototype['knowledgeGraphResults'] = undefined;






export default GetSavedAnnotationAdditionalContentResponse;

